import React from "react";
import { withSearch } from "@elastic/react-search-ui";
import URLManager from "@elastic/search-ui/lib/URLManager";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';
import queryString from "qs";

function stateToParams({
  searchTerm,
  current,
  filters,
  resultsPerPage,
  sortDirection,
  sortField,
  sortList,
  family,searchMode,price_sort,typeView
}) {
  const params = {};
  if (current > 1) params.current = current;
  if (searchTerm) params.q = searchTerm;
  if (resultsPerPage) params.size = "n_"+resultsPerPage+"_n";
  if (filters && filters.length > 0) {
    params["filters"] = filters;
  }
  if (family) params.engine = family;
  if (searchMode) params.search_mode = searchMode;
  if (price_sort) params.price_sort = price_sort;
  if (typeView) params.view = typeView;
  if (sortField) {
    params["sort-field"] = sortField;
    params["sort-direction"] = sortDirection;
  }
  return params;
}

function stateToQueryString(state) {
  return window.location.protocol + "//" + window.location.host + "/find.php?"+queryString.stringify(stateToParams(state));
}

async function copyPageUrl(url,t) {
  try {
    await navigator.clipboard.writeText(url);
    alert(t('Search URL copied to clipboard'));
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}

function ShareUrl({filters,searchMode, family,price_sort,typeView,sortDirection,sortField,current,resultSearchTerm,t}) {
  
  const geturl = () => {

  /*    console.log("family:"+family); 
      console.log("searchMode:"+searchMode); 
      console.log("filters:"+filters);
      console.log("price_sort:"+price_sort);
      console.log("typeView:"+typeView);
      console.log("sortDirection:"+sortDirection);
      console.log("sortField:"+sortField);
      console.log("current:"+current);
      console.log("resultSearchTerm:"+resultSearchTerm);*/
      
      
      copyPageUrl(stateToQueryString({searchTerm:resultSearchTerm,current:current,filters:filters,resultsPerPage:60,sortDirection:sortDirection,sortField:sortField,sortList:[],family:family,searchMode:searchMode,price_sort:price_sort,typeView:typeView}),t);

      
  }

  
  
  return (
    <div className="clear-filter-wrapper">
      <button className="btn share-btn" onClick={
        () => geturl()
        }>
        <i className="share-icon">
          <img src="/img/svgs/share_icon.svg" className="normal-img" alt="share-icon" />
          <img src="/img/svgs/share_icon-over.svg" className="hover-img" alt="share-icon" />
        </i>
      </button>
    </div>
  );
}

export default withSearch(({ filters, searchMode, family,price_sort,typeView,sortDirection,sortField,current,resultSearchTerm}) => ({filters, searchMode, family,price_sort,typeView}))(withTranslation()(ShareUrl));